import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  GridItem,
  Image,
  Select,
  SimpleGrid,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from '@chakra-ui/react';

import React, { useEffect, useState } from 'react';
import Card from 'components/card/Card';
import BackButton from 'components/BackButton';
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { useLocation, useNavigate } from 'react-router-dom';
import { createAPIEndPoint } from 'config/api/api';
import toast from 'react-hot-toast';
import { logoutUser } from 'utils';
import Loader from 'loaders/Loader';
import moment from 'moment';

export default function ServicesDetails(props) {
  const navigate = useNavigate();
  const location = useLocation();
  // const { id } = location.state;
  const pathParts = location.pathname.split('/');
  const id = pathParts[pathParts.length - 1];
  const [loading, setLoading] = useState(true);
  const [service, setService] = useState([]);

  const imageUrl =
    'https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png';

  const getServices = async () => {
    try {
      setLoading(true);
      const response = await createAPIEndPoint('services').fetchById(`/${id}`);
      const service = response.data.service;
      console.log(service, 'Service');

      setService(service);

      setLoading(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Error fetching team details',
      );
      if (error?.response?.data?.error.includes('Bearer token')) {
        logoutUser(navigate);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    getServices();
  }, [id]);

  return (
    <>
      {loading && <Loader />}
      <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
        <BackButton />
        {/* Main Fields */}
        <Grid templateColumns={{ base: '1fr', md: 'repeat(1, 1fr)' }} gap={6}>
          <Card p={6} w="100%">
            <Text color="gray.700" fontWeight="bold" fontSize="2xl" mb={6}>
              Service Details
            </Text>

            <Grid
              templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
              gap={6}
            >
              {/* Code */}
              <GridItem>
                <Box>
                  <Text fontWeight="semibold" color="gray.700" mb={1}>
                    Code:
                  </Text>
                  <Text color="gray.500">{service?.code || 'N/A'}</Text>
                </Box>
              </GridItem>

              {/* Office Code */}
              <GridItem>
                <Box>
                  <Text fontWeight="semibold" color="gray.700" mb={1}>
                    Office Code:
                  </Text>
                  <Text color="gray.500">{service?.office_code || 'N/A'}</Text>
                </Box>
              </GridItem>

              {/* Description */}
              <GridItem>
                <Box>
                  <Text fontWeight="semibold" color="gray.700" mb={1}>
                    Description:
                  </Text>
                  <Text color="gray.500">{service?.description || 'N/A'}</Text>
                </Box>
              </GridItem>

              {/* Amount IL */}
              <GridItem>
                <Box>
                  <Text fontWeight="semibold" color="gray.700" mb={1}>
                    Amount IL:
                  </Text>
                  <Text color="gray.500">${service?.amount_il ?? 'N/A'}</Text>
                </Box>
              </GridItem>

              {/* Amount WI */}
              <GridItem>
                <Box>
                  <Text fontWeight="semibold" color="gray.700" mb={1}>
                    Amount WI:
                  </Text>
                  <Text color="gray.500">${service?.amount_wi ?? 'N/A'}</Text>
                </Box>
              </GridItem>

              {/* Treatment Area */}
              <GridItem>
                <Box>
                  <Text fontWeight="semibold" color="gray.700" mb={1}>
                    Treatment Area:
                  </Text>
                  <Text color="gray.500">
                    {service?.treatment_area_name || 'N/A'}
                  </Text>
                </Box>
              </GridItem>

              {/* Category */}
              <GridItem>
                <Box>
                  <Text fontWeight="semibold" color="gray.700" mb={1}>
                    Category:
                  </Text>
                  <Text color="gray.500">
                    {service?.category_name || 'N/A'}
                  </Text>
                </Box>
              </GridItem>

              <GridItem>
                <Box>
                  <Text fontWeight="semibold" color="gray.700" mb={1}>
                    Created At:
                  </Text>
                  <Text color="gray.500">
                    {service?.created_at
                      ? moment(service?.created_at).format('MM/DD/YYYY')
                      : 'N/A'}
                  </Text>
                </Box>
              </GridItem>
            </Grid>
          </Card>
        </Grid>
      </Box>
    </>
  );
}
